(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/helpers/dialog.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/helpers/dialog.js');
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var dialog = svs.ui.dialog;

var button = function button(_ref) {
  var title = _ref.title,
    callback = _ref.callback;
  return {
    title: title,
    callback: callback ? callback : function () {}
  };
};

var injectToButtonCallbacks = function injectToButtonCallbacks(buttons, injection) {
  buttons.forEach(function (button) {
    var theCallback = button.callback;
    button.callback = function (dialog, form) {
      injection();
      theCallback(dialog, form);
    };
  });
  return buttons;
};

var text = function text(_ref2) {
  var text = _ref2.text;
  return {
    text: text,
    type: dialog.message.TEXT
  };
};

var checkbox = function checkbox(_ref3) {
  var checked = _ref3.checked,
    text = _ref3.text,
    value = _ref3.value;
  return {
    checked: typeof checked === 'boolean' ? checked : false,
    text: text || '',
    type: dialog.message.CHECKBOX,
    value: typeof value === 'boolean' ? value : false
  };
};

var grType = {
  ERROR: 'error',
  INFO: 'info',
  DEFAULT: 'default'
};
var toDialogType = function toDialogType(type) {
  switch (type) {
    case grType.ERROR:
      return dialog.type.ERROR;
    case grType.INFO:
    case grType.DEFAULT:
    default:
      return dialog.type.DEFAULT;
  }
};

var grIcon = _defineProperty(_defineProperty(_defineProperty({}, grType.ERROR, 'exclamation-sign'), grType.INFO, 'information'), grType.DEFAULT, 'information');

var DEFAULTBUTTON = [button({
  title: 'Ok'
})];
var TENANT = svs.core.detect.tenant('lb') ? 'SPORT' : 'TUR';

var newDialog = function newDialog(_ref4) {
  var _dialog$api;
  var area = _ref4.area,
    autoClose = _ref4.autoClose,
    buttons = _ref4.buttons,
    convertToPopup = _ref4.convertToPopup,
    icon = _ref4.icon,
    message = _ref4.message,
    title = _ref4.title,
    type = _ref4.type;
  var theDialog = new dialog.Confirm({
    actions: injectToButtonCallbacks(buttons || DEFAULTBUTTON, function () {
      return theDialog.close();
    }),
    area: area || dialog.area.POPUP,
    autoClose: autoClose || 0,
    branding: dialog.branding[TENANT],
    convertToPopup: convertToPopup || false,
    icon: icon || grIcon[type],
    message: message || [],
    title: title,
    type: toDialogType(type)
  });
  if ((_dialog$api = dialog.api) !== null && _dialog$api !== void 0 && (_dialog$api = _dialog$api.queue) !== null && _dialog$api !== void 0 && _dialog$api.count()) {
    dialog.api.close();
  }
  dialog.api.add(theDialog);

  autoClose && setTimeout(function () {
    return theDialog.close();
  }, autoClose);
  return theDialog;
};

var errorPopup = function errorPopup(_ref5) {
  var title = _ref5.title,
    message = _ref5.message;
  return newDialog({
    area: dialog.area.POPUP,
    message: [text({
      text: message
    })],
    title: title,
    type: grType.ERROR
  });
};

var infoPopup = function infoPopup(_ref6) {
  var title = _ref6.title,
    message = _ref6.message;
  return newDialog({
    area: dialog.area.POPUP,
    message: [text({
      text: message
    })],
    title: title,
    type: grType.INFO
  });
};

var errorToaster = function errorToaster(_ref7) {
  var autoClose = _ref7.autoClose,
    title = _ref7.title,
    message = _ref7.message;
  return newDialog({
    autoClose: autoClose || dialog.autoClose.SHORT,
    area: dialog.area.TOASTER,
    message: [text({
      text: message
    })],
    title: title,
    type: grType.ERROR
  });
};

var infoToaster = function infoToaster(_ref8) {
  var autoClose = _ref8.autoClose,
    title = _ref8.title,
    message = _ref8.message;
  return newDialog({
    autoClose: autoClose || dialog.autoClose.SHORT,
    area: dialog.area.TOASTER,
    message: [text({
      text: message
    })],
    title: title,
    type: grType.INFO
  });
};
svs.grassroots.helpers.dialog = {
  autoClose: dialog.autoClose,
  errorPopup: errorPopup,
  errorToaster: errorToaster,
  infoPopup: infoPopup,
  infoToaster: infoToaster
};

 })(window);